import { Injectable } from '@angular/core';
import { RegisteredEmployeeManagementControllerService } from '@iota/inh-core-v1-management-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap, take } from 'rxjs';
import {
    LoadRegisteredEmployeeCounts,
    LoadRegisteredEmployeeCountsFailure,
    LoadRegisteredEmployeeCountsSuccess,
    LoadRegisteredEmployeeList,
    LoadRegisteredEmployeeListFailure,
    LoadRegisteredEmployeeListSuccess
} from '../actions/registered-employee.actions';

@Injectable()
export class RegisteredEmployeeEffects {
    loadRegisteredEmployeeList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadRegisteredEmployeeList),
            switchMap(({ params }) =>
                this.registeredEmployeeService
                    .findAll(
                        params.status,
                        params.companyIds?.length ? params.companyIds : undefined,
                        params.searchQuery,
                        params.pageIndex,
                        params.pageSize,
                        params.sortingField,
                        params.sortingAscending ?? true
                    )
                    .pipe(
                        take(1),
                        map((page) =>
                            LoadRegisteredEmployeeListSuccess({
                                employees: page.content ?? [],
                                totalElements: page.totalElements ?? 0,
                                pageIndex: params.pageIndex,
                                pageSize: params.pageSize
                            })
                        ),
                        catchError((error) => of(LoadRegisteredEmployeeListFailure({ error })))
                    )
            )
        )
    );

    loadRegisteredEmployeeCounts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadRegisteredEmployeeCounts),
            mergeMap(() =>
                this.registeredEmployeeService.getCounts().pipe(
                    take(1),
                    map((counts) =>
                        LoadRegisteredEmployeeCountsSuccess({
                            counts: {
                                active: counts.activeEmployeeCount ?? 0,
                                former: counts.formerEmployeeCount ?? 0
                            }
                        })
                    ),
                    catchError((error) => of(LoadRegisteredEmployeeCountsFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private registeredEmployeeService: RegisteredEmployeeManagementControllerService
    ) {}
}
